import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../services/authStore'

export default function AdminRoute({ children }) {
  const location = useLocation()
  const { isInitializing, user } = useAuthStore()

  if (isInitializing) {
    return null
  }

  const isAdmin = Boolean(user?.is_admin ?? user?.isAdmin)
  if (!isAdmin) {
    return <Navigate to="/" replace state={{ from: location }} />
  }

  return children
}
